import React from 'react';
import MultipleSelectField from 'components/pure/utils/select-field/MultipleSelectField';
import './TopicSelect.sass';

export default class TopicSelect extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      // freetext/typeahead dropdown current value
      currentSearchTerm: '',
    };

    this.topicOptions = this.topicOptions.bind(this);
  }

  topicOptions() {
    const {topics} = this.props;
    const {currentSearchTerm} = this.state;
    return topics
      .filter(w => w.word.toLowerCase().indexOf(currentSearchTerm.toLowerCase()) > -1)
      .map(w => {
        return {label: w.word, value: w.id, id: w.id};
      })
      .toArray()
      .sort((a, b) => (a.label > b.label ? 1 : -1)); // alphabetical sort by label
  }

  render() {
    const {topics, handleAddTopic} = this.props;
    const {currentSearchTerm} = this.state;

    const topicOptions = this.topicOptions(topics, currentSearchTerm);

    return (
      <MultipleSelectField
        removeItem={this.props.removeKeywordTopicComboboxItem}
        containerClassName="topic-select"
        selectField={{
          name: 'term',
          className: 'search-sidebar-select-field',
          placeholder: 'Select topic',
          noResultsMessage: 'No Results',
          options: topicOptions,
          onChange: handleAddTopic,
          onSearchChange: currentSearchTerm => this.setState({currentSearchTerm}),
          search: currentSearchTerm,
          filterOptions: options => options,
        }}
      />
    );
  }
}
